import React from 'react';
import * as R from 'ramda';
import { injectTool } from '../../initializers/injectors';
import SetDateFormat from './component';


const registerSetDateFormat = R.pipeP(
  injectTool('SetDateFormat', ({ instance }) => ({
    type: 'customElement',
    title: 'Set Date Format',
    render: () => (
      <SetDateFormat
        annotManager={instance.annotManager}
        instance={instance}
      />
    ),
  }))
);


export default registerSetDateFormat;
